import { useState, useEffect, useRef } from "react";
import { styled, alpha } from "@mui/material/styles";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";

import DeleteIcon from "@mui/icons-material/Delete";

import {
  Button,
  IconButton,
  ListItemIcon,
  ListItemText,
  TextField,
  Divider,
} from "@mui/material";

import Toast from "components/Toast";
import { Note, Delete, ContentCopy } from "@mui/icons-material";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 80,
    backgroundColor: "#383838",
    color:
      theme.palette.mode === "light"
        ? "rgb(255, 255, 255)"
        : "rgb(255, 255, 255)",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: "rgb(255, 255, 255)",
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

export default function ExtraLoraEditMenu({
  showNoteDialog,
  copyTriggerWords,
  removeLora,
}) {
  const [alert, setAlert] = useState({
    show: false,
    severity: "success",
    msg: "",
  });

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCopyTriggerWords = () => {
    setAnchorEl(null);
    copyTriggerWords();
  };

  return (
    <div>
      <Toast alert={alert} setAlert={setAlert}></Toast>
      <IconButton aria-label="open" onClick={handleClick} variant="contained">
        <MenuOpenIcon fontSize="inherit" sx={{ color: "#fff" }} />
      </IconButton>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{ backdropFilter: "blur(2px)" }}
      >
        <MenuItem
          disableRipple
          onClick={() => {
            showNoteDialog(true);
            setAnchorEl(null);
          }}
        >
          <ListItemIcon>
            <Note />
          </ListItemIcon>
          <ListItemText>Note</ListItemText>
        </MenuItem>
        <MenuItem disableRipple onClick={handleCopyTriggerWords}>
          <ListItemIcon>
            <ContentCopy />
          </ListItemIcon>
          <ListItemText>Copy trigger words</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem disableRipple onClick={removeLora}>
          <ListItemIcon>
            <Delete />
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
        </MenuItem>
      </StyledMenu>
    </div>
  );
}
